import React, { useState } from 'react';
import { Box, Tag, Text, Grid, Button, Notify } from '@flexisaf/flexibull2';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';
import request from 'utils/request';
import urls from 'utils/config';
import { EMPTY_VALUE } from 'utils/constants';
import {
  formatAddress,
  formatCountry,
} from '../ApplicantModals/SingleApplicant';
import { formatApplicantDate } from '../utils';
import EditRefereeModal from './EditRefereeModal';

const moment = require('moment-timezone');

const CollapsibleBox = styled.div`
  & .referee-card {
    border: 1px solid rgb(216, 216, 227);
    border-radius: 5px;
    padding: 0px;
    margin-bottom: 15px;
    box-shadow: rgba(59, 6, 237, 0.1) 0px 1px 3px;
    & .referee-card-header {
      cursor: pointer;
      text-align: left;
      padding: 15px;
      font-size: 1em;
      display: flex;
      background: none;
      grid-template-columns: auto max-content;
      align-items: center;
      justify-content: space-between;
    }
    & .referee-details {
      border-top: 1px solid rgba(216, 216, 227, 0.7);
      padding: 25px 15px;
      text-align: left;
      background: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      max-height: 400px;
      overflow: auto;
      & .single-form {
        /* margin-left: 10px; */
        position: relative;
        box-shadow: 0px 5px 3px rgba(0, 0, 0, 0.03);
        /* &::before {
          content: '•';
          position: absolute;
          left: -10px;
          top: 0px;
          color: ${(props) => props.theme.PrimaryInputOutline};
        } */
      }
    }
  }
`;

const { API_BASE_URL } = urls || {};

export default function RefereeTab({ referees, onRefereeUpdated }) {
  const [expandedRow, setExpandedRow] = useState(null);
  const [renotifying, setRenotifying] = useState('');
  const [editReferee, setEditReferee] = useState(null);

  const handleExpandRow = (key) => {
    if (key === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(key);
    }
  };

  const notifyReferee = async (index, id) => {
    setRenotifying(index);
    const url = `${API_BASE_URL}/candidates/referees/notify`;
    const response = await request({
      method: 'post',
      data: {
        ids: [id],
      },
      url,
    });
    if (response.success) {
      setRenotifying('');
      Notify('Referee has been notified succesfully', {
        position: 'top-right',
        status: 'success',
      });
    } else {
      setRenotifying('');
      return;
    }
  };

  return (
    <Box margin="0 0 0" width="900px">
      <CollapsibleBox>
        {referees?.map((referee, i) => (
          <div key={i} className="referee-card">
            <>
              <div
                onClick={() => handleExpandRow(i)}
                className="referee-card-header"
              >
                <Text bold>
                  <i
                    className={
                      expandedRow === i ? `saf-up-open` : `saf-down-open`
                    }
                    style={{ marginRight: '10px' }}
                  />
                  {referee?.name} - {referee?.email} -{' '}
                  {referee?.phone && `+${referee?.phone}`}{' '}
                </Text>
                <>
                  <Button
                    pale
                    spaceRight="0"
                    iconRight={
                      <i style={{ fontSize: '13px' }} className="saf-edit" />
                    }
                    spaceLeft="auto"
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditReferee(referee);
                    }}
                  >
                    Edit referee
                  </Button>
                  {referee?.status.toLowerCase() !== 'submitted' && (
                    <Button
                      pale
                      spaceRight="0"
                      iconRight={
                        <i style={{ fontSize: '13px' }} className="saf-mail" />
                      }
                      spaceLeft="auto"
                      onClick={(e) => {
                        e.stopPropagation();
                        notifyReferee(i, referee?.id);
                      }}
                      progress={renotifying === i}
                    >
                      Renotify
                    </Button>
                  )}
                  <Tag
                    solid
                    spaceLeft
                    small
                    color={
                      referee?.status.toLowerCase() === 'submitted'
                        ? Theme.PrimaryGreen
                        : Theme.PrimaryYellow
                    }
                  >
                    {referee?.status.toLowerCase() === 'submitted'
                      ? 'Submitted'
                      : 'Not Submitted'}
                  </Tag>
                </>
              </div>
              {expandedRow === i && (
                <div className="expanded referee-details">
                  {referee?.status.toLowerCase() === 'submitted'
                    ? referee?.inputs?.map((eachRow, rowIndex) => (
                        <Grid
                          className="form-grid"
                          default="1fr"
                          gap="15px"
                          key={`row-${rowIndex}`}
                          style={{ marginBottom: '15px' }}
                        >
                          {eachRow.map((eachField, i) => (
                            <Box key={i} className="single-form">
                              <Text
                                color={({ theme }) => theme.PrimaryInputOutline}
                                uppercase
                                bold
                                block
                              >
                                {eachField?.title}
                              </Text>

                              {eachField?.source === 'nigeria-states-lga' ? (
                                <Text capitalize size="15px" block>
                                  {formatAddress(
                                    referee?.data?.data[eachField?.id]
                                  )}
                                </Text>
                              ) : eachField?.source === 'countries' ? (
                                <Text capitalize size="15px" block>
                                  <p>
                                    {formatCountry(
                                      referee?.data?.data[eachField?.id]
                                    )}
                                  </p>
                                </Text>
                              ) : (
                                <Text
                                  capitalize={
                                    !['email', 'wysiwyg'].includes(
                                      eachField?.type?.toLowerCase()
                                    )
                                  }
                                  size="15px"
                                  block
                                >
                                  {eachField?.type === 'checkbox' ? (
                                    <>
                                      {referee?.data?.data[eachField.id]
                                        ? eachField.trueDisplay
                                        : eachField.falseDisplay}
                                    </>
                                  ) : (
                                    <>
                                      {['date', 'single-date'].includes(
                                        eachField?.type?.toLowerCase()
                                      ) &&
                                      referee?.data?.data[eachField?.id] ? (
                                        <p>
                                          {moment(
                                            formatApplicantDate(
                                              referee?.data?.data[eachField?.id]
                                            )
                                          ).format('MMMM Do YYYY')}
                                        </p>
                                      ) : (
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              referee?.data?.data[
                                                eachField?.id
                                              ] || EMPTY_VALUE,
                                          }}
                                        />
                                      )}
                                    </>
                                  )}
                                </Text>
                              )}
                            </Box>
                          ))}
                        </Grid>
                      ))
                    : 'This Referee has not submitted any response'}
                </div>
              )}
            </>
          </div>
        ))}
      </CollapsibleBox>
      <EditRefereeModal
        open={!!editReferee}
        referee={editReferee}
        onClose={() => setEditReferee(null)}
        onSuccess={onRefereeUpdated}
      />
    </Box>
  );
}

RefereeTab.propTypes = {
  referees: PropTypes.array,
  formItem: PropTypes.array,
  onRefereeUpdated: PropTypes.func,
};
